import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const PageOverlayHeader = ({
	title,
	onBack,
	badges,
	buttons,
	meta,
	endButtons,
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: '14px',
				padding: '0 18px',
				height: 52,
				borderBottom: '0.5px solid',
				borderColor: 'border.main',
				backgroundColor: 'background.paper',
				flexShrink: 0,
			}}
		>
			<Box
				component='button'
				onClick={onBack}
				sx={{
					fontSize: '12px',
					fontWeight: 500,
					color: 'status.blue.text',
					background: 'transparent',
					border: '0.5px solid',
					borderColor: 'status.blue.border',
					borderRadius: '6px',
					padding: '5px 12px',
					cursor: 'pointer',
					fontFamily: 'inherit',
					'&:hover': { backgroundColor: 'status.blue.bg' },
				}}
			>
				← Overview
			</Box>
			<Typography
				sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary' }}
			>
				{title}
			</Typography>
			{badges}
			{buttons}
			{meta && (
				<Typography
					sx={{
						fontSize: '12px',
						color: 'text.secondary',
						marginLeft: 'auto',
					}}
				>
					{meta}
				</Typography>
			)}
			{endButtons}
		</Box>
	);
};

PageOverlayHeader.propTypes = {
	title: PropTypes.string.isRequired,
	onBack: PropTypes.func.isRequired,
	badges: PropTypes.node,
	buttons: PropTypes.node,
	meta: PropTypes.string,
	endButtons: PropTypes.node,
};

export default PageOverlayHeader;
